/// <amd-module name="Wit/Filter/FilterStateManager" />
import { FilterState } from "Wit/Filter/FilterManager";
import { TimerManagement } from "VSS/Core/TimerManagement";
import { IVssPageContext } from "VSS/Platform/Context";
import { ISettingsService, SettingsUserScope } from "VSS/Platform/Settings";

const FilterSaveDelayInMs = 1000;

/**
 * Manages the persistence of the filter state.
 */
export class FilterStateManager {
    private _timerManagement: TimerManagement = new TimerManagement(this);
    private _pageContext: IVssPageContext;

    constructor(pageContext: IVssPageContext, private _scopeId: string, private _registryKey: string, private _filterState: FilterState, private _scopeName: string = "Project") {
        this._pageContext = pageContext;
    }

    public saveFilter(filters: FilterState): void {
        this._filterState = filters;
        this._saveFilterThrottleDelegate();
    }

    public setFilterState(filters: FilterState): void {
        this._filterState = filters;
    }

    public resetFilter(): void {
        this.saveFilter({});
    }

    public getFilterState(): FilterState {
        return this._filterState;
    }

    private _saveFilterThrottleDelegate = this._timerManagement.throttle(() => {
        const settingsService = this._pageContext.getService<ISettingsService>("ISettingsService");
        const entries: { [key: string]: any } = { [this._registryKey]: this._filterState };
        settingsService.setEntries(entries, SettingsUserScope.Me, this._scopeName, this._scopeId);
    }, FilterSaveDelayInMs);
    
}
